import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProcedureStepFieldsRevisionSettingsDetailViewTopBar } from "./TopBar"

export const procedureStepFieldsRevisionSettingsDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProcedureStepFieldsRevisionSettingsDetailViewTopBar,
}
